// extracted by mini-css-extract-plugin
export default {"Icon":"DiagnosticExpired_Icon__wp06b","Title":"DiagnosticExpired_Title__d4kq9","Description":"DiagnosticExpired_Description__WcxVk"};